import { APP_VERSION } from '@/version';

import FacilityTabs from '@/components/FacilityTabs';
import { useAuth } from '@/store/auth';

export default function FacilityDashboard() {
  const { user } = useAuth();

  if (!user || user.role !== 'facility') {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <p className="text-red-600">Access denied. Facility account required.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8 max-w-7xl">
      {/* Header */}
      <div className="mb-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold flex items-center gap-3">
              <div className="p-2 bg-primary/10 rounded-lg">
                <svg className="h-8 w-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              {user.facilityId} Dashboard
            </h1>
            <p className="text-muted-foreground mt-2">
              Manage your facility's stream schedules and overlays
            </p>
          </div>
          
          <div className="flex items-center gap-4">
            <div className="text-right">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-sm font-medium">Facility User</span>
              </div>
              <div className="text-xs text-muted-foreground">v{APP_VERSION}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <FacilityTabs />
    </div>
  );
}
